import React, { useEffect, useState, forwardRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./component.scss";
import { formatNumber } from "../../../../common/Validations";

const StatusCountForLedgers = forwardRef((props, ref) => {
  const [loadData, setLoadData] = useState(props?.statuscountdata);
  const [getLedgerName, setLedgerName] = useState(props?.ldgerName);

  useEffect(() => {
    setLoadData(props?.statuscountdata);
    setLedgerName(props?.ldgerName);
  }, [props]);
  return (
    <div className="my-4" ref={ref}>
      <form className="">
        {loadData && (
          <Row>
            <Col xs={12} md={12} lg={12} className="">
              <div className="card mb-0">
                <div className="card-body statusCountScroll">
                  {/* {loadData.map((item) => (
                    <span
                      key={item.id}
                      className={getStatusClassName(item.name)}
                    >
                      {item.name} - {item.count}
                    </span>
                  ))} */}
                  {getLedgerName === "Customer" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Basic Amount:{" "}
                        {formatNumber(loadData[0].totalAmount, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Bags: {formatNumber(loadData[0].totalBags, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Net Amount:{" "}
                        {formatNumber(loadData[0].totalNetValue, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "CGST" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        CGST: {formatNumber(loadData[0].totalCgst, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "SGST" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        SGST: {formatNumber(loadData[0].totalSgst, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "RoundOff" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        RoundOff:{" "}
                        {formatNumber(loadData[0].totalAmount, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Stock Summary" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Purchase Amount:{" "}
                        {formatNumber(
                          loadData[0].totalPurchaseBasicAmount,
                          "comma"
                        )}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Purchase Bags:{" "}
                        {formatNumber(loadData[0].totalPurchaseBags, "comma")}
                      </span>

                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Sales Amount:{" "}
                        {formatNumber(
                          loadData[0].totalSalesBasicAmount,
                          "comma"
                        )}
                      </span>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Sales Bags:{" "}
                        {formatNumber(loadData[0].totalSalesBags, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                        Balance Bags:{" "}
                        {formatNumber(loadData[0].totaBalanceBags, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-danger-status px-4 mr-2">
                        Balance Amount:{" "}
                        {formatNumber(loadData[0].totaBalanceBasicAmount, "comma")}
                      </span>
                    </>
                  )}

                  {getLedgerName === "Company" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Bags: {formatNumber(loadData[0].totalBags, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Basic: {formatNumber(loadData[0].totalBasic, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        CGST: {formatNumber(loadData[0].totalCgst, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        SGST: {formatNumber(loadData[0].totalSgst, "comma")}
                      </span>

                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Total Amt:{" "}
                        {formatNumber(loadData[0].totalAmount, "comma")}
                      </span>

                      {/* purchase */}
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Pur Bags :{" "}
                        {formatNumber(loadData[0].totalPurchaseBags, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Pur Basic:{" "}
                        {formatNumber(
                          loadData[0].totalPurchaseBasicAmount,
                          "comma"
                        )}
                      </span>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Pur CGST:{" "}
                        {formatNumber(loadData[0].totalPurchaseCgst, "comma")}
                      </span>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Pur SGST:{" "}
                        {formatNumber(loadData[0].totalPurchaseSgst, "comma")}
                      </span>

                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Pur Total Amt:{" "}
                        {formatNumber(
                          loadData[0].totalPurchaseTotalAmount,
                          "comma"
                        )}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Outward CGST 14%" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Outward CGST 14%:{" "}
                        {formatNumber(loadData[0].cgstValue_14, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Outward SGST 14%" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Outward SGST 14%:{" "}
                        {formatNumber(loadData[0].sgstValue_14, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Outward CGST 9%" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Outward CGST 9%:{" "}
                        {formatNumber(loadData[0].cgstValue_9, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Outward SGST 9%" && (
                    <>
                      <span className="bg-table-status bg-table-success-status px-4 mr-2">
                        Outward SGST 9%:{" "}
                        {formatNumber(loadData[0].sgstValue_9, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Inward CGST 14%" && (
                    <>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Outward CGST 14%:{" "}
                        {formatNumber(loadData[0].poCgstValue_14, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Inward SGST 14%" && (
                    <>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Outward SGST 14%:{" "}
                        {formatNumber(loadData[0].poSgstValue_14, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Inward CGST 9%" && (
                    <>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Outward CGST 9%:{" "}
                        {formatNumber(loadData[0].poCgstValue_9, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Inward SGST 9%" && (
                    <>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        Outward SGST 9%:{" "}
                        {formatNumber(loadData[0].poSgstValue_9, "comma")}
                      </span>
                    </>
                  )}
                  {getLedgerName === "Inward IGST " && (
                    <>
                      <span className="bg-table-status bg-table-new-status px-4 mr-2">
                        IGST: {formatNumber(loadData[0].poTotalIgst, "comma")}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        )}
      </form>
    </div>
  );
});

export default StatusCountForLedgers;
